/* eslint-disable nonblock-statement-body-position */
/* eslint-disable curly */
const formattedAreas = [];

export const flattenCategories = (
  categories = [],
  level = 0,
  clearAll = false
) => {
  if (clearAll) formattedAreas.length = 0;
  if (categories.length <= 0) return [];
  const filteredAreas = [];
  categories.forEach((category) => {
    formattedAreas.push({
      level,
      ...category,
      value: category.id,
    });
    if (category?.children?.length > 0)
      flattenCategories(category?.children, level + 1);
  });
  formattedAreas.forEach((a) => {
    if (!filteredAreas.map((fa) => fa.value)?.includes(a.value))
      filteredAreas.push(a);
  });
  return filteredAreas;
};

export const getCategoriesIds = (categories = [], fallback) => {
  if (categories?.length === 0) return [fallback];
  return categories.map((c) => c?.value);
};

export const getChildrenCategories = (category = {}) => {
  const { children = [] } = category;
  return flattenCategories(children, 0, true);
};
